import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><h1 class=\"anchor fw-bolder mb-5\"><a href=\"#message-box\"></a> MessageBox </h1><div class=\"py-5\"> A set of modal boxes simulating system message box, mainly for alerting information, confirm operations and prompting messages. </div><div class=\"py-5\"><div class=\"rounded py-5 px-5 bg-light-info\"> By design MessageBox provides simulations of system&#39;s <code>alert</code>, <code>confirm</code> and <code>prompt</code>，so it&#39;s content should be simple. For more complicated contents, please use Dialog. </div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIAlert = _resolveComponent("EUIAlert")
  const _component_EUIConfirm = _resolveComponent("EUIConfirm")
  const _component_EUIPrompt = _resolveComponent("EUIPrompt")
  const _component_EUICustomization = _resolveComponent("EUICustomization")
  const _component_EUIUseHTMLString = _resolveComponent("EUIUseHTMLString")
  const _component_EUIDistinguishingCancelAndClose = _resolveComponent("EUIDistinguishingCancelAndClose")
  const _component_EUICenteredContent = _resolveComponent("EUICenteredContent")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIAlert),
    _createVNode(_component_EUIConfirm),
    _createVNode(_component_EUIPrompt),
    _createVNode(_component_EUICustomization),
    _createVNode(_component_EUIUseHTMLString),
    _createVNode(_component_EUIDistinguishingCancelAndClose),
    _createVNode(_component_EUICenteredContent)
  ], 64))
}